import React from 'react';
import {ComponentPreview, Previews} from '@react-buddy/ide-toolbox';
import {PaletteTree} from './palette';
import Accordion from "../views/base/accordion/Accordion";
import CalendarDeal from "../views/base/schedul/calendar/CalendarDeal";

const ComponentPreviews = () => {
  return (
    <Previews palette={<PaletteTree/>}>
      <ComponentPreview path="/Accordion">
        <Accordion/>
      </ComponentPreview>
        <ComponentPreview path="/CalendarDeal">
            <CalendarDeal/>
        </ComponentPreview>
    </Previews>
  );
};

export default ComponentPreviews;
